import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { Chart } from 'chart.js';
import { ActionSheetController } from '@ionic/angular';
import{ApiService} from '../../../services/api.service';

@Component({
  selector: 'app-member-teacher',
  templateUrl: './member-teacher.page.html',
  styleUrls: ['./member-teacher.page.scss'],
})
export class MemberTeacherPage implements OnInit {

  constructor(
    private api:ApiService, 
    private router:Router, 
    public actionSheetController: ActionSheetController) { 

  	this.getClassroomData();
    this.getEkskulData();
  }

  ngOnInit() {
  }

  ionViewDidEnter(){
    this.api.isLoggedIn();
    this.getUserData();
    this.getKelas();
    this.getEkskul();
  }

  tugasSemester:any='gasal';
  toggleTugasSemester()
  {
    if(this.tugasSemester=='gasal') this.tugasSemester='genap';
    else this.tugasSemester='gasal';
  }

  userData:any={};
  getUserData()
  {
    this.api.data('user/me','get','').subscribe(data=>{
        this.parseUserData(data);
    },error=>{
        this.router.navigate(['/page/tabs/member']);
    })
  }
  parseUserData(data)
  {
      if(data.coverUrl=='')
      data.coverUrl='assets/imgs/green.svg';
      if(data.profileUrl=='') 
      data.profileUrl='assets/imgs/dark.svg';
      this.userData=data;
  }

  kelas:any={};
  getKelas()
  {
      this.api.data('guru/kelas','get','').subscribe(data=>{
          this.parseKelas(data);
      })
  }
  parseKelas(data)
  {
      this.kelas['gasal']=[];
      this.kelas['genap']=[];
      for(var i=0; i<data.length; i++)
      {
          if(data[i].semester=='GASAL')
          this.kelas.gasal.push(data[i]);
          else this.kelas.genap.push(data[i]);
      }      
  }
  ekskul:any=[];
  getEkskul()
  {
      this.api.data('guru/ekskul','get','').subscribe(data=>{
          this.ekskul=data;
      })
  }

  detailKelas(data)
  {
      this.router.navigate(['/page/tabs/member/teacher/detail-classroom',data.id]);
  }

  inputNilai(){
    this.router.navigate(['/page/tabs/member/teacher/input-nilai-ekskul'])
  }
  isTransparent:boolean=true;
  onScroll($event) {    
    if ($event && $event.detail && $event.detail.scrollTop) { 
      if($event.detail.scrollTop >= 225)    
      this.isTransparent = false;
      else this.isTransparent = true;
    }
  }


  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Tindakan',
      buttons: [{
        text: 'Detail',
        icon: 'eye',
        handler: () => {
          this.inputNilai();
          console.log('Detail clicked');
        }
      }, {
        text: 'Arsipkan',
        icon: 'archive',
        handler: () => {
          console.log('arsip clicked');
        }
      }]
    });
    await actionSheet.present();
  }


  color:any=['bg-grey-dark','bg-bluegrey-dark','bg-bluegrey-primary', 'bg-bluegrey-light'];
  getColor()
  {
  		var rand=Math.floor((Math.random() * 4));
  		return this.color[rand];
  }

  classRoomData:any=[];
  getClassroomData()
  {
  		this.classRoomData=[
  			{
  				kelas:'I A',
  				mapel:'Matematika',
  				color: this.getColor()
  			},
  			{
  				kelas:'II B',
  				mapel:'Ilmu Pengetahuan Alam',
  				color: this.getColor()
  			},
  			{
  				kelas:'I C',
  				mapel:'Ekonomi',
  				color: this.getColor()
  			}
  		]
  }

  EkskulData:any=[];
  getEkskulData()
  {
    this.EkskulData=[
    {
      ekskul:'Badminton',
      color: this.getColor()
    },
    {
      ekskul:'Futsal',
      color: this.getColor()
    }
    ]
  }

    async optEkskul(dat) {
    const actionSheet = await this.actionSheetController.create({
      header: 'Tindakan',
      buttons: [{
        text: 'Masukkan Nilai',
        icon: 'checkmark-circle',
        handler: () => {
          this.router.navigate(['/page/tabs/member/teacher/input-nilai-ekskul',dat.id]);
        }
      }, {
        text: 'Pengaturan',
        icon: 'settings',
        handler: () => {
          this.router.navigate(['/page/tabs/member/teacher/ekskul-setting',dat.id]);
        }
      }]
    });
    await actionSheet.present();
  }


}
